/* What the year comes to, per broker.
 *
 * This was a group inside settings, which is where a thing goes when nobody is
 * expected to look at it. It is not that kind of screen: the figures move every
 * time a sale or a dividend is recorded, and the year they add up to is checked
 * more than once. So it is a tab.
 *
 * It reports and it does not advise (§1). The rates come from the country
 * chosen or from fields typed by hand, and every total says which — an app that
 * quietly supplied a foreign rate would be handing over a figure nobody had
 * checked, on the one screen where that gets carried onto a form. */

import { useState } from 'react';
import { TabBar } from '../components/TabBar';
import { TaxReport } from '../components/TaxReport';
import { TradeLog } from '../components/TradeLog';
import { HideToggle } from '../components/HideToggle';
import { useStore } from '../state/store';
import type { Nav } from '../App';

export function TaxesScreen({ nav }: { nav: Nav }) {
  const { state } = useStore();
  const [toast, setToast] = useState<string | null>(null);
  const say = (m: string) => { setToast(m); window.setTimeout(() => setToast(null), 3600); };

  const shelteredCount = state.data.accounts.filter((a) => a.taxShielded).length;

  return (
    <div className="screen" data-tabbed="true">
      <div className="screen-head">
        <h1>Taxes</h1>
        <span className="meta" style={{ marginLeft: 'auto' }}>per broker, per year</span>
        <HideToggle />
      </div>

      <TaxReport say={say} />

      {/* The rows the figures above are built out of. They were written by
          Reduce and by the importer and then never shown anywhere, so "the
          report says this" had no answer to "out of what?". */}
      <TradeLog say={say} />

      <div className="dim" style={{ fontSize: 11, marginTop: 16, lineHeight: 1.5 }}>
        Sales reach this screen through the trade log and dividends through the dividends screen,
        so a year is only as complete as what has been recorded into it. A year you did not keep
        records for will read short, and reading short is the failure mode worth knowing about.
        {shelteredCount > 0
          ? ` ${shelteredCount} account${shelteredCount === 1 ? ' is' : 's are'} marked sheltered `
            + 'under Brokers and stay out of every total above.'
          : ' No account is marked sheltered. If one of yours is, say so under Brokers and it '
            + 'drops out of these totals.'}
      </div>

      {toast ? <div className="toast">{toast}</div> : null}

      <TabBar current="taxes" go={nav.go} />
    </div>
  );
}
